import axios from 'axios';
import each from 'lodash/each';

import * as config from '../../config';

export default {
  state: {
    sort: 'LastIntakeDate',
    sortDirection: 'DESC',
    animals: [],
    totalAnimals: 0,
    maxPages: 0,
    search: '',
    species: 'All',
    animalSpecies: [],
    gender: 'All',
    ageGroup: 'All',
    ageGroups: [],
    animal: null,
    primaryBreeds: [],
    secondaryBreeds: [],
    primaryColors: [],
    secondaryColors: [],
    primaryBreed: 'All',
    secondaryBreed: 'All',
    primaryColor: 'All',
    secondaryColor: 'All',
    needsPhoto: false,
  },
  actions: {
    async getAnimals({ rootState, state, commit }) {
      try {
        let params = [
          `page=${encodeURIComponent(rootState.route.params.page || 1)}`,
          `limit=${encodeURIComponent(config.PAGE_SIZE)}`,
          `sort=${encodeURIComponent(state.sort)}`,
          `dir=${encodeURIComponent(state.sortDirection)}`,
          `search=${encodeURIComponent(state.search)}`,
          `species=${encodeURIComponent(state.species)}`,
          `gender=${encodeURIComponent(state.gender)}`,
          `ageGroup=${encodeURIComponent(state.ageGroup)}`,
          `primaryBreed=${encodeURIComponent(state.primaryBreed)}`,
          `secondaryBreed=${encodeURIComponent(state.secondaryBreed)}`,
          `primaryColor=${encodeURIComponent(state.primaryColor)}`,
          `secondaryColor=${encodeURIComponent(state.secondaryColor)}`,
          `needsPhoto=${encodeURIComponent(state.needsPhoto)}`,
        ];

        let response = await axios.get(`${config.API_URL}/animals?${params.join('&')}`);

        commit('setAnimals', response);

        return response;
      } catch (e) {}
    },
    async getAnimalSpecies({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/species`);

        commit('update', { state, property: 'animalSpecies', value: response.data });

        return response;
      } catch (e) {}
    },
    async getAgeGroups({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/age-groups`);

        commit('update', { state, property: 'ageGroups', value: response.data });

        return response;
      } catch (e) {}
    },
    async getPrimaryBreeds({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/primary-breeds?species=${encodeURIComponent(state.species)}`);

        commit('update', { state, property: 'primaryBreeds', value: response.data });

        return response;
      } catch (e) {}
    },
    async getSecondaryBreeds({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/secondary-breeds?species=${encodeURIComponent(state.species)}`);

        commit('update', { state, property: 'secondaryBreeds', value: response.data });

        return response;
      } catch (e) {}
    },
    async getPrimaryColors({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/primary-colors?species=${encodeURIComponent(state.species)}`);

        commit('update', { state, property: 'primaryColors', value: response.data });

        return response;
      } catch (e) {}
    },
    async getSecondaryColors({ state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/secondary-colors?species=${encodeURIComponent(state.species)}`);

        commit('update', { state, property: 'secondaryColors', value: response.data });

        return response;
      } catch (e) {}
    },
    async getAnimal({ rootState, state, commit }) {
      try {
        let response = await axios.get(`${config.API_URL}/animals/${rootState.route.params.animalId}`);

        response.data.currentPhoto = 1;

        commit('update', { state, property: 'animal', value: response.data });

        return response;
      } catch (e) {}
    },
  },
  mutations: {
    setAnimals(state, { data }) {
      each(data.items, animal => animal.currentPhoto = 1);

      state.animals = data.items;

      state.totalAnimals = data.total_results;

      state.maxPages = Math.ceil(data.total_results / config.PAGE_SIZE);
    },
    prevPhoto(state, animal) {
      if (animal.currentPhoto === 1 && animal.Photo3) {
        animal.currentPhoto = 3;
      } else if (
        animal.currentPhoto === 1 && animal.Photo2 ||
        animal.currentPhoto === 3 && animal.Photo2
      ) {
        animal.currentPhoto = 2;
      } else if (
        animal.currentPhoto === 2 ||
        animal.currentPhoto === 3
      ) {
        animal.currentPhoto = 1;
      }
    },
    nextPhoto(state, animal) {
      if (animal.currentPhoto === 1 && animal.Photo2) {
        animal.currentPhoto = 2;
      } else if (
        animal.currentPhoto === 1 && animal.Photo3 ||
        animal.currentPhoto === 2 && animal.Photo3
      ) {
        animal.currentPhoto = 3;
      } else if (
        animal.currentPhoto === 2 ||
        animal.currentPhoto === 3
      ) {
        animal.currentPhoto = 1;
      }
    },
  },
  getters: {
    animalPages(state, getters, rootState) {
      let page = parseInt(rootState.route.params.page) || 1,
        numPages = state.maxPages < 5 ? state.maxPages : 5,
        pages = [];

      if (page <= Math.ceil(numPages / 2)) {
        for (let i = 1; i <= numPages; i++) {
          pages.push(i);
        }
      } else if (page > state.maxPages - Math.floor(numPages / 2)) {
        for (let i = state.maxPages; i > state.maxPages - numPages; i--) {
          pages.push(i);
        }
        pages.reverse();
      } else {
        return [page - 2, page - 1, page, page + 1, page + 2];
      }

      return pages;
    }
  },
};